module.exports = __webpack_public_path__ + "static/media/bancontact.6f8a29a1.svg";